
const ContactSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            まずはお気軽にご相談ください
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed">
            物件探しや売却など、お客様の状況に合わせて最適なご提案をいたします。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              無料査定はこちら
            </button>
            <button className="bg-white hover:bg-gray-50 text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              お問い合わせフォームへ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
